import { trapFocus, removeTrapFocus } from 'dom-utils';

class SearchPanel extends HTMLElement {
  constructor() {
    super();
    this.triggerButton = this.querySelector('#search-panel-btn');
    this.panel = this.querySelector('.search-modal');
    this.header = document.querySelector('#shopify-section-header');
    this.countdownTimer = document.querySelector('.section-countdown-timer');
    this.announcementBar = document.querySelector('.section-announcement-bar');
    this.headerSearchPanel = document.querySelector('.search-modal__content');
    this.headerSearch = document.querySelector('.header-search');
    this.handleResize = this.onResize.bind(this);
    this.resizeRaf = null;

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.triggerButton.addEventListener(
      'click',
      this.onTriggerClick.bind(this)
    );
    this.querySelector('button[data-close-header-search]').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.querySelector('button[data-close-header-search]').addEventListener(
      'keydown',
      e => {
        if (e.key === ' ' || e.key === 'Enter') {
          this.close();
        }
      }
    );
  }

  isOpen() {
    return this.hasAttribute('open');
  }

  onTriggerClick() {
    this.isOpen() ? this.close() : this.open();
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains('overlay-open')
    )
      this.close(false);
  }

  getElementHeight(element) {
    return element ? element.getBoundingClientRect().height : 0;
  }

  calculateHeaderSearchPanelTop() {
    if (!this.headerSearchPanel) return 0;

    if (this.header?.classList.contains('shopify-section-header-sticky')) {
      return 0;
    }

    const countdownHeight = this.getElementHeight(this.countdownTimer);
    const announcementHeight = this.getElementHeight(this.announcementBar);
    const searchModalHeight = this.getElementHeight(this.panel);
    const headerSearchHeight = this.getElementHeight(this.headerSearch);

    // Keep visual alignment when modal container and header search heights diverge.
    const modalHeightDiff = Math.max(0, searchModalHeight - headerSearchHeight);

    return Math.round(countdownHeight + announcementHeight + modalHeightDiff);
  }

  updateHeaderSearchPanelTop() {
    if (!this.headerSearchPanel) return;
    this.headerSearchPanel.style.top =
      this.calculateHeaderSearchPanelTop() + 'px';
  }

  onResize() {
    if (!this.isOpen()) return;
    if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
    this.resizeRaf = requestAnimationFrame(() => {
      this.updateHeaderSearchPanelTop();
      this.resizeRaf = null;
    });
  }

  open() {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.setAttribute('open', '');
    this.panel.removeAttribute('inert');
    this.triggerButton.setAttribute('aria-expanded', 'true');
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden', 'overlay-open');
    this.updateHeaderSearchPanelTop();
    window.addEventListener('resize', this.handleResize);
    trapFocus(this.panel, this.panel.querySelector('.ais-SearchBox-input'));
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.triggerButton : null);
    this.removeAttribute('open');
    this.panel.setAttribute('inert', '');
    this.triggerButton.setAttribute('aria-expanded', 'false');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    window.removeEventListener('resize', this.handleResize);
    if (this.resizeRaf) {
      cancelAnimationFrame(this.resizeRaf);
      this.resizeRaf = null;
    }
    document.body.classList.remove('overflow-hidden', 'overlay-open');
  }
}

if (!customElements.get('search-panel')) {
  customElements.define('search-panel', SearchPanel);
}
